import { render, staticRenderFns } from "./AuctionCardContent.vue?vue&type=template&id=193bceff&scoped=true"
import script from "./AuctionCardContent.vue?vue&type=script&lang=js"
export * from "./AuctionCardContent.vue?vue&type=script&lang=js"
import style0 from "./AuctionCardContent.vue?vue&type=style&index=0&id=193bceff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193bceff",
  null
  
)

export default component.exports